export const ELECTROCRAFT_PUCK_CHILDREN_SLOT = 'children';
export const ELECTROCRAFT_PUCK_DIAGNOSTIC_COMPONENT = '__ElectroCraftDiagnostic';
export const ELECTROCRAFT_PUCK_DIAGNOSTIC_CODE_PROP = '__electrocraftDiagnosticCode';
export const ELECTROCRAFT_PUCK_DIAGNOSTIC_REF_PROP = '__electrocraftComponentRef';
export const ELECTROCRAFT_PUCK_DIAGNOSTIC_PROPS_PROP = '__electrocraftProps';
